/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import AnalysisIcons from "../../../CommonUi/AnalysisIcons/AnalysisIcons";
import { COMPLIANCE_COLOR_CODES } from "../../../../services/config";
import { findDomainOfPrinciple, principleAnchorId, scrollToPrinciple } from "../../../../helpers/principleTokens";

interface SummaryPrincipleIconProps {
  token?: string;
  groups?: any[];
}

const wrapperStyle = css`
  display: inline-flex;
  vertical-align: middle;
  margin: 0 2px;
`;

export default function SummaryPrincipleIcon({ token, groups }: Readonly<SummaryPrincipleIconProps>) {
  const [domainKey, index] = (token ?? "").split(".");
  const domain = findDomainOfPrinciple(groups, domainKey, Number(index));
  if (!domain) {
    return null;
  }
  const color = COMPLIANCE_COLOR_CODES[String(domain.category) as keyof typeof COMPLIANCE_COLOR_CODES] ?? "#EAEEF0";
  return (
    <span css={wrapperStyle}>
      <AnalysisIcons
        show="smallIcon"
        imgName={domain.domain_name}
        colorId={color}
        scrollTo={() => scrollToPrinciple(principleAnchorId(domain.domain_name, Number(index)))}
      />
    </span>
  );
}
